import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarTwo = _resolveComponent("NavbarTwo")!
  const _component_MainBanner = _resolveComponent("MainBanner")!
  const _component_WhoWeAre = _resolveComponent("WhoWeAre")!
  const _component_OurFeatures = _resolveComponent("OurFeatures")!
  const _component_OurContent = _resolveComponent("OurContent")!
  const _component_EnjoyYourTime = _resolveComponent("EnjoyYourTime")!
  const _component_FavoriteMatch = _resolveComponent("FavoriteMatch")!
  const _component_PricingPlans = _resolveComponent("PricingPlans")!
  const _component_TestOurService = _resolveComponent("TestOurService")!
  const _component_OnlyBenefits = _resolveComponent("OnlyBenefits")!
  const _component_OurTestimonial = _resolveComponent("OurTestimonial")!
  const _component_FanFact = _resolveComponent("FanFact")!
  const _component_FAQ = _resolveComponent("FAQ")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_CopyRight = _resolveComponent("CopyRight")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavbarTwo),
    _createVNode(_component_MainBanner),
    _createVNode(_component_WhoWeAre),
    _createVNode(_component_OurFeatures),
    _createVNode(_component_OurContent),
    _createVNode(_component_EnjoyYourTime, {
      class: "bg-gondola3",
      className: "text-white"
    }),
    _createVNode(_component_FavoriteMatch),
    _createVNode(_component_PricingPlans),
    _createVNode(_component_TestOurService),
    _createVNode(_component_OnlyBenefits),
    _createVNode(_component_OurTestimonial),
    _createVNode(_component_FanFact),
    _createVNode(_component_FAQ),
    _createVNode(_component_MainFooter, {
      class: "bg-secondary bg-img",
      style: _normalizeStyle({ backgroundImage: `url(${_ctx.bgImage})` })
    }, null, 8, ["style"]),
    _createVNode(_component_CopyRight)
  ], 64))
}